import { ISiteSketchesList } from "@/types/SitesSketches";
import { create } from "zustand";
import { ItemUIConfigModel, SortModel } from "./viewJobItemDetailStore";

export type Job = {
  sketchJobId: string | null;
  sketchJobCode: string | null;
  sketchNumber: number;
  sketchProjectName: string | null;
  sketchJobAddress: string | null;
  sketchProjectId: string | null;
  companyId: string | null;
  poNumber: string | null;
  status: string | null;
  confirmDelivery: boolean;
  dueDate: string | null;
  orderDate: string | null;
  qcDate: string | null;
  completedDate: string | null;
  state: string | null;
  drawing: string | null;
  drawingLink: string | null;
  orderBy: string | null;
  companyName: string | null;
  id: string;
};

export type JobPageData = {
  count: number | null;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  page: number | null;
  pageSize: number | null;
  totalPages: number | null;
  totalRecords: number | null;
  type: string | null;
};

type SketchStore = {
  page: number | undefined;
  pageSize: number | undefined;
  search_text: string | undefined;
  siteSketchList: ISiteSketchesList[];
  siteSketchListPageData: JobPageData | undefined;
  setSiteSketchList: (list: ISiteSketchesList[] | ((prev: ISiteSketchesList[]) => ISiteSketchesList[])) => void;
  setSiteSketchListPageData: (pageData: JobPageData) => void;
  reset: () => void;
  isAnyFilterApply: boolean;
  resetPageOnly: () => void;
  sortModel: SortModel;
  setSortModel: (sortModel: SortModel) => void;
  setPageSize: (pageSize?: number) => void;
  setPage: (page?: number) => void;
  setSearchText: (searchText?: string) => void;
  uiConfig: ItemUIConfigModel[];
  setUIConfig: (uiConfig: ItemUIConfigModel[]) => void;
  order_by?: string | undefined;
  setOrderBy: (orderBy?: string) => void;
  appendSiteSketchList: (list: ISiteSketchesList[]) => void;
};

export const useSketchStore = create<SketchStore>(set => ({
  page: 0,
  pageSize: 15,
  search_text: "",
  sortModel: {
    columnKey: "orderDate",
    order: "descend"
  },
  isAnyFilterApply: false,
  siteSketchList: [],
  siteSketchListPageData: undefined,
  setSiteSketchList: listOrFn =>
    set(state => ({
      siteSketchList:
        typeof listOrFn === "function" ? (listOrFn as (prev: ISiteSketchesList[]) => ISiteSketchesList[])(state.siteSketchList) : listOrFn
    })),
  setSortModel: (value: SortModel) => set({ sortModel: value }),
  setSiteSketchListPageData: pageData => set({ siteSketchListPageData: pageData }),
  reset: () =>
    set({
      page: 1,
      siteSketchList: [],
      siteSketchListPageData: undefined,
      isAnyFilterApply: true
    }),
  resetPageOnly: () =>
    set({
      page: 1,
      isAnyFilterApply: true
    }),
  setPageSize: pageSize => set({ pageSize: pageSize }),
  setPage: page => set({ page: page }),
  setSearchText: searchText => set({ search_text: searchText }),
  uiConfig: [],
  setUIConfig: (value: ItemUIConfigModel[]) => set({ uiConfig: value }),
  setOrderBy: orderBy => set({ order_by: orderBy }),
  appendSiteSketchList: list =>
    set(state => {
      if (state.page === 1) {
        const existingIds = new Set(state.siteSketchList.map(job => job.id));
        const newUniqueItems = list.filter(job => !existingIds.has(job.id));
        return {
          siteSketchList: [...state.siteSketchList, ...newUniqueItems]
        };
      } else {
        return {
          siteSketchList: [...state.siteSketchList, ...list]
        };
      }
    })
}));
